(function ($) {

    $(document).ready(function () {
        init();
    });

    function init() {
        var $sidebarLinks = $('.component.sidebar-nav .component.link a');
        if (!$sidebarLinks.length || window.WEP && window.WEP.isPageEditor()) return;
        var currentURL = location.href.replace(location.search, '').split('#')[0];
        var shortURL = currentURL.split('/');
        shortURL = shortURL.filter(Boolean);
        var shortURL_active = "/" + shortURL[shortURL.length - 1];
        if (window.location.hash !== "") {
            shortURL_active = shortURL_active + window.location.hash;
        }
        function compareSpacesToDashes(link1, link2) {
            if (link2.indexOf('-') > 0) {
                link1 = link1.replace(/%20/g, '-');
                link2 = link2.replace(/%20/g, '-');
            }
            return link1 === link2;
        }

        $sidebarLinks.each(function () {
            if ($(this).attr('href')) {
                linkURL = $(this).attr('href');
                if (linkURL.substr(-1) === '/') {
                    linkURL = linkURL.substr(0, linkURL.length - 1);
                }
                if (linkURL !== undefined) {
                    shortLinkURL = linkURL.split('/');
                    finalLinkURL = "/" + shortLinkURL[shortLinkURL.length - 1];
                    if (linkURL && !$(this).closest('.sidebar-nav').find('a.active').length) {
                        linkURL = linkURL[linkURL.length - 1] === '/' ? linkURL.substring(0, linkURL[linkURL.length - 2]) : linkURL;
                        if (linkURL.indexOf('http') > -1 && compareSpacesToDashes(currentURL, encodeURI(linkURL))) {
                            $(this).addClass('active');
                            $(this).attr('aria-current', 'page');
                        } else if (compareSpacesToDashes(shortURL_active, encodeURI(linkURL))) {
                            $(this).addClass('active');
                            $(this).attr('aria-current', 'page');
                        } else if (compareSpacesToDashes(shortURL_active, encodeURI(finalLinkURL))) {
                            $(this).addClass('active');
                            $(this).attr('aria-current', 'page');
                        }
                    }
                    //Issue 1.16 Sidebar navigation list is implemented incorrectly. SC team changes
                    var heading = $('.sidebar-nav-title').children(":header");
                    for (var i = 0; i < heading.length; i++) {

                        //Since aria-label value is coming from Sitecore, we are removing below functionality
                        /* var headingId = $(heading[i]).text().replace(/ /g, '');
                          $(heading[i]).attr('id', headingId);
                          $('.sidebar-nav-title').parent('div').attr('aria-labelledby', headingId);*/

                        $('.component.sidebar-nav .component.link a.active').attr("aria-current", "page");
                    }

                }
            }
            else {
                return false;
            }
        });

    }

}(window.jQuery));

